if (!window.jng) {
    window.jng = {}
    jng.isUndefined = function (obj) {
        return obj === undefined || obj === null;
      };
    
      jng.isDefined = function (args) {
        var i, iArgumentLength;
        for (i = 0, iArgumentLength = arguments.length; i < iArgumentLength; i += 1) {
            if (jng.isUndefined(arguments[i])) {
                return false;
            }
        }
        return true;
      };
      jng.isArray = function (obj) {
        return obj instanceof Array;
    };
    jng.isObject = function (obj) {
        if (jng.isArray(obj)) return false;
        return obj instanceof Object;
    };
    
    
    jng.isFunction = function (obj) {
        return obj instanceof Function;
    };
    
    jng.isString = function(obj) {
        return (typeof obj) === 'string';
    };
    jng.isDate = function (obj) {
        var result = obj instanceof Date;
        if (result) {
            if (isNaN(obj.getTime())) {
                return false;
            }
        }
        return result;
    };
    
    jng.isBoolean = function(obj) {
        return obj === true || obj === false;
    }
    
    jng.isLiteral = function (obj) {
        if (jng.isArray(obj)) {
            return false;
        }
        if (jng.isObject(obj)) {
            return false;
        }
        return true;
    };
    
    jng.isValueEqual = function (valueData1, valueData2) {    
        if (valueData1 instanceof Date) {
            return (function isDateEqual(date1, date2) {
                if (date1.compareDate(date2) == 0) {
                    return true;
                }
                return false;
            })(valueData1, valueData2);
        } else if (jng.isString(valueData1) && jng.isString(valueData2)) {
            return valueData1.trim().toLowerCase() == valueData2.trim().toLowerCase() 
        }
        return valueData1 == valueData2;
    };
    
    jng.isObjectEqual = function (data1, data2, arzProperty) {
        //Begin-Code
        var idxHeader;
        for (idxHeader = 0; idxHeader < arzProperty.length; idxHeader += 1) {
            var valueData1 = data1[arzProperty[idxHeader]];
            var valueData2 = data2[arzProperty[idxHeader]];
            if (!jng.isValueEqual(valueData1, valueData2)) {
                return false;
            }
        }
        return true;
    };
    
    jng.getPropertyValue = function (obj, arzProp) {
        var currObj = obj;
        var i;
        for (i = 0; i < arzProp.length; i += 1) {
            currObj = jng.getValueOfObject(currObj, arzProp[i]);
            if (jng.isUndefined(currObj)) {
                return undefined;
            }
        }
        return currObj;
    };
    
    jng.getValueOfObject = function (objSrc, propertyName) {
        if (jng.isUndefined(objSrc)) {
            return undefined;
        }
        if (propertyName == undefined) {
            return undefined;
        }
        if (propertyName == '') {
            return undefined;
        }
        if (objSrc == null) {
            return undefined;
        }
        if (propertyName.startsWith('"') || propertyName.startsWith("'")) {
            return propertyName.substring(1, propertyName.length - 1);
        }
    
        var props = propertyName.split('.');
        var i;
        var result = objSrc;
        for (i = 0; i < props.length; i++) {
            const propElList = props[i].split('[')
            const propName = propElList[0]
            if (jng.isUndefined(result[propName])) return undefined
            result = result[propName]
    
            for (let arrIdx = 1; arrIdx < propElList.length; arrIdx++) {
                const propEl = propElList[arrIdx]
                const idx = propEl.substring(0, propEl.length - 1)
                if (jng.isUndefined(result[idx])) return undefined
                result = result[idx]
            }
        }
        return result;
    }
    
    jng.setValueOfObject = function (objSrc, propertyName, value) {
        var props = propertyName.split('.');
        var i;
        var result = objSrc;
        for (i = 0; i < props.length - 1; i++) {
            const propElList = props[i].split('[')
            const propName = propElList[0]
            if (jng.isUndefined(result[propName])) result[props[i]] = {};
            result = result[propName]
    
            for (let arrIdx = 1; arrIdx < propElList.length; arrIdx++) {
                const propEl = propElList[arrIdx]
                const idx = propEl.substring(0, propEl.length - 1)
                if (jng.isUndefined(result[idx])) result[idx] = {}
                result = result[idx]
            }
        }
        result[props[props.length - 1]] = value;
    }
    
    jng.coalesce = function (args) {
        var i;
        for (i = 0; i < arguments.length; i++) {
            if (jng.isDefined(arguments[i])) {
                return arguments[i];
            }
        }
    }
    
    jng.coalesceProp = function (obj, arzProp, nullValue) {
        if (jng.isDefinedProperty(obj, arzProp)) {
            return jng.getPropertyValue(obj, arzProp);
        }
        return nullValue;
    };
    
    jng.isEmpty = function(objOrStr) {
        if (jng.isUndefined(objOrStr)) return true
        if (jng.isObject(objOrStr)) {
            for (let prop in objOrStr) {
                if (objOrStr.hasOwnProperty(prop)) {
                    if (jng.isEmpty(objOrStr[prop])) return true
                }
            }
            return false
        }
        if (objOrStr.trim() == '') return true
        return false
    }
    jng.coalesceAndEmpty = function (args) {
        var i;
        for (i = 0; i < arguments.length; i++) {
            if (jng.isDefined(arguments[i])) {
                if (arguments[i] == '' && i < arguments.length - 1) {
                    continue;
                }
                return arguments[i];
            }
        }
    }
    
    jng.cloneLiteral = function (obj) {
        var result = {};
        var prop;
        for (prop in obj) {
            if (obj.hasOwnProperty(prop)) {
                result[prop] = obj[prop];
            }
        }
        return result;
    };
    
    jng.clone = function (objOrArr) {
        function cloneObject(obj) {
            var result = {};
            var prop;
            for (prop in obj) {
                if (obj.hasOwnProperty(prop)) {
                    if (jng.isArray(obj[prop])) {
                        var currObjArr = obj[prop];
                        result[prop] = [];
                        for(var i = 0; i < currObjArr.length; i++) {
                            result[prop][i] = jng.clone(currObjArr[i]);
                        }
                    } else if (jng.isDate(obj[prop])) {
                        result[prop] = new Date(obj[prop].getTime());
                    } else if (obj[prop] instanceof Function) {
                        result[prop] = obj[prop];
                    } else if (jng.isObject(obj[prop])) {
                        result[prop] = jng.clone(obj[prop]);
                    } else {
                        result[prop] = obj[prop];
                    }
                }
            }
            return result;
        }
    
        //BEGIN
        if (!jng.isObject(objOrArr) && !jng.isArray(objOrArr)) {
            return objOrArr;
        }
    
        if (jng.isArray(objOrArr)) {
            var result = [];
            var i;
            for (i = 0; i < objOrArr.length; i++) {
                result.push(cloneObject(objOrArr[i]));
            }
            return result;
        }
    
        return cloneObject(objOrArr);
    };
    
    jng.isObjectEqual = function (obj1, obj2, arzProp) {
        if (jng.isUndefined(obj1)) return false
        if (jng.isUndefined(obj2)) return false
        let props = arzProp
        if (jng.isUndefined(arzProp)) {
            props = []
            for (let prop in obj1) {
                if (obj1.hasOwnProperty(prop)) {
                    props.push(prop)
                }
            }
        }
        for (let i = 0; i < props.length; i++) {
            let prop = props[i]
            if (jng.isUndefined(obj1[prop])) return false
            if (jng.isUndefined(obj2[prop])) return false
            if (obj1[prop] != obj2[prop]) return false
        }
        return true
    };
    
    jng.compareArray = function(arr1, arr2){
        if(!jng.isArray(arr1) || !jng.isArray(arr2)){
            console.warn("is not an array");
            return false;
        }
        
        let isDifferent = true;
    
        if(arr1.length>arr2.length)return isDifferent;
        let checker1 = [];
        for (var obj1 of arr1) {
            let isHaveIdenticObject = false;
            for (var obj2 of arr2) {
                if(typeof obj1 == 'object' && typeof obj2 == 'object'){
                    if(jng.compareObject(obj1, obj2)==false) isHaveIdenticObject = true;
                }else if(obj1==obj2)isHaveIdenticObject = true;
                
            }
            checker1.push(isHaveIdenticObject);
        }
    
        let checker2 = [];
        for (var obj2 of arr2) {
            let isHaveIdenticObject = false;
            for (var obj1 of arr1) {
                if(typeof obj1 == 'object' && typeof obj2 == 'object'){
                    if(jng.compareObject(obj2, obj1)==false) isHaveIdenticObject = true;
                }else if(obj1==obj2)isHaveIdenticObject = true;
            }
            checker2.push(isHaveIdenticObject);
        }
    
        let opt = checker1.find(e=>e==false);
        if(jng.isDefined(opt))return isDifferent;
        opt = checker2.find(e=>e==false);
        if(jng.isDefined(opt))return isDifferent;
    
        isDifferent =false;
        return isDifferent
    }
    
    jng.compareObject = function(obj1, obj2, isWithArray){
        if(jng.isUndefined(isWithArray))isWithArray = false;
        let sizeObj1 = 0, sizeObj2 = 0;
        for(let prop in obj1)sizeObj1++;
        for(let prop in obj2)sizeObj2++;
        let mainObject = sizeObj1>sizeObj2? obj1 : obj2;
        let checker = [];
        for(let prop in mainObject){
            let isDifferent = true;
            if(jng.isDefined(obj1[prop]) && jng.isDefined(obj2[prop])){
                if(jng.isArray(obj1[prop]) && jng.isArray(obj2[prop])){
                    if(isWithArray)isDifferent = jng.compareArray(obj1[prop], obj2[prop]);
                }else if(typeof obj1[prop] == 'object' && typeof obj2[prop] == 'object'){
                    isDifferent = jng.compareObject(obj1[prop], obj2[prop]);
                }else isDifferent = obj1[prop] == obj2[prop];
            }else isDifferent = true;
            checker.push(isDifferent);
        }
        let opt = checker.find(e=>e==false);
        if(jng.isDefined(opt))return true;
        else return false;
    }
    
    
    jng.updateObject = function(obj, updateObj) {
        var prop;
        for (prop in obj) {
            if (obj.hasOwnProperty(prop)) {
                if (jng.isDefined(updateObj[prop])) {
                    obj[prop] = updateObj[prop];
                }
            }
        }
    };
    
    jng.traverseProperty = function(obj, funcProcess) {
        var prop;
        for (prop in obj) {
            if (obj.hasOwnProperty(prop)) {
                funcProcess(prop);
            }
        }
    };
    
    jng.emptyPromise = function() {
        return new Promise(function(resolve){resolve();})
    }
    
      jng.isDefinedProperty = function (obj, arzProp) {
        if (jng.isUndefined(obj)) {
            return false;
        }
    
        var value = jng.getPropertyValue(obj, arzProp);
        if (jng.isUndefined(value)) {
            return false;
        }
        return true;
     };
    
    
    jng.createurl = function(idList){
        if(jng.isArray(idList)){
            var slash = "/";
            var inc = 0;
            for(const list of idList){
                inc++;
                slash = slash + list ;
                if(inc !== idList.length){
                    slash = slash + "/";
                }
            }
            var result = slash;
            return result;
        }
    };

    jng.unReactiveObject = function(obj){
        var temp = [obj];
        temp = temp.clone();
        return temp[0];
    };

    jng.createSearchQuery = function (queryParams) {
        var result = "";
        var i;
        for (i = 0; i < queryParams.length; i += 1) {
            if (queryParams[i].szValue === "") {
                continue;
            }
            if (result !== "") {
                result += "[;]";
            }
            result += queryParams[i].szName + "[=]" + queryParams[i].szValue;
        }
        return result;
    };
        
}
